module.exports = __webpack_public_path__ + "static/media/5_rectangle.2fc6545e.png";